import { Redirect } from "@reach/router";
import usePlan from "hooks/usePlan";
import { Form } from "./Form";

/**
 * `/teams/:teamID/suscripcion` (y `/subscription`) sin plan en la ruta. Es el link que Ventas
 * comparte hoy, así que sigue siendo el alta de siempre hasta que se prendan los planes
 * (cronograma 5/11). Con el enforcement prendido el api rechaza el alta sin plan
 * (422 plan_required), y el camino es Planes.
 *
 * Si `/access` falla se muestra el formulario: con enforcement el POST igual devuelve
 * plan_required y el Form lo manda a Planes.
 */
export function SubscriptionEntry({ teamID, ...props }) {
  const plan = usePlan();

  if (plan.isLoading) {
    return (
      <div className="text-center mt-3">
        <span className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} role="status"></span>
      </div>
    );
  }

  if (plan.enforced) return <Redirect noThrow to={`/teams/${teamID}/planes`} />;

  return <Form teamID={teamID} {...props} />;
}
